// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IQuestion } from './iQuestion.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ISurvey {
    'key': string;
    'questions': Array<IQuestion>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ISurvey>> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "questions",
            "baseName": "questions",
            "type":     "Array<IQuestion>"
        },
    ];

    static getAttributeTypeMap() {
        return ISurvey.attributeTypeMap;
    }
}
